import { baseTheme as theme } from './theme'

export default theme
